var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEstabilidad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#GradientFill_3-4);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#GradientFill_3-5);\n      }\n\n      .cls-3 {\n        fill: url(#GradientFill_3-7);\n      }\n\n      .cls-4 {\n        fill: url(#GradientFill_3-6);\n      }\n\n      .cls-5 {\n        fill: url(#GradientFill_3-2);\n      }\n\n      .cls-6 {\n        fill: url(#GradientFill_3-3);\n      }\n\n      .cls-7 {\n        fill: url(#GradientFill_3);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3",
    "data-name": "GradientFill 3",
    x1: 25,
    y1: 50,
    x2: 25,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa780c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#d1b24a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5d06a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-2",
    "data-name": "GradientFill 3",
    x1: 20.81,
    y1: 50.01,
    x2: 20.81,
    y2: 0.01,
    xlinkHref: "#GradientFill_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-3",
    "data-name": "GradientFill 3",
    x1: 32.8,
    y1: 50.01,
    x2: 32.8,
    y2: 0.01,
    xlinkHref: "#GradientFill_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-4",
    "data-name": "GradientFill 3",
    x1: 28.05,
    y1: 50.01,
    x2: 28.05,
    y2: 0.01,
    xlinkHref: "#GradientFill_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-5",
    "data-name": "GradientFill 3",
    x1: 24.51,
    y1: 50.01,
    x2: 24.51,
    y2: 0.01,
    xlinkHref: "#GradientFill_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-6",
    "data-name": "GradientFill 3",
    x1: 27.34,
    y1: 50.01,
    x2: 27.34,
    y2: 0.01,
    xlinkHref: "#GradientFill_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-7",
    "data-name": "GradientFill 3",
    x1: 20.98,
    y1: 50.01,
    x2: 20.98,
    y2: 0.01,
    xlinkHref: "#GradientFill_3"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M25,0C11.22,0,0,11.21,0,25s11.22,25,25,25,25-11.22,25-25S38.78,0,25,0ZM25,46.94c-12.1,0-21.94-9.84-21.94-21.94S12.9,3.06,25,3.06s21.94,9.84,21.94,21.94-9.84,21.94-21.94,21.94Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M21.97,26.87c0-2.4-.74-4.05-1.33-5.38-.45-1.01-.8-1.81-.8-2.73,0-7.94,13.65-8.37,13.79-8.38.64-.02,1.14-.55,1.12-1.18-.02-.63-.53-1.13-1.15-1.13h-.03c-.16,0-3.95.11-7.79,1.38-5.4,1.79-8.25,5-8.25,9.3,0,1.42.51,2.56,1,3.67.55,1.24,1.13,2.53,1.13,4.44,0,1.5-4.61,4.88-12.05,7.74-.59.23-.89.9-.66,1.49.18.46.61.74,1.08.74.14,0,.28-.02.41-.08,3.17-1.22,13.53-5.54,13.53-9.9Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M32.45,21.13c-1.71-1.32-2.67-2.13-2.67-3.32,0-3.25,6.85-4.17,6.92-4.18.63-.08,1.08-.65,1.01-1.28-.08-.63-.65-1.09-1.28-1.01-.37.04-8.95,1.13-8.95,6.47,0,2.38,1.81,3.79,3.57,5.15,2.35,1.82,4.78,3.7,4.78,8.23,0,5.69-4.91,9.72-4.95,9.76-.5.4-.58,1.12-.18,1.62.23.28.56.43.9.43.25,0,.51-.08.72-.25.24-.19,5.82-4.75,5.82-11.55,0-5.66-3.28-8.2-5.67-10.05Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29,11.04c-.06.02-1.47.54-2.97,1.61-.52.37-.64,1.09-.27,1.61.23.32.58.49.94.49.23,0,.46-.07.67-.21,1.24-.88,2.41-1.32,2.42-1.32.6-.22.91-.88.69-1.48-.22-.6-.88-.91-1.48-.69Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.33,24.57c.52-.37.63-1.09.26-1.61-.21-.29-.42-.57-.62-.84-.85-1.11-1.46-1.92-1.46-2.95,0-.22.02-.44.05-.65.09-.63-.35-1.22-.98-1.31-.63-.09-1.22.34-1.31.98-.05.32-.07.65-.07.98,0,1.81.94,3.04,1.93,4.34.19.25.39.52.59.79.23.31.58.48.94.48.23,0,.47-.07.67-.22Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M27.7,27.93c-.63.07-1.09.64-1.02,1.28.05.46.08.95.08,1.45,0,1.27-.33,2.47-.99,3.55-.33.54-.16,1.25.39,1.59.19.11.39.17.6.17.39,0,.77-.2.99-.56.88-1.45,1.32-3.05,1.32-4.74,0-.59-.03-1.16-.09-1.71-.07-.63-.64-1.09-1.28-1.02Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M21.82,37.77c-1.4.78-2.57,1.13-2.58,1.13-.61.18-.96.82-.79,1.43.15.5.61.83,1.11.83.11,0,.22-.02.32-.05.06-.02,1.41-.42,3.05-1.33.56-.31.76-1.01.45-1.57-.31-.56-1.01-.76-1.57-.45Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEstabilidad);
export default __webpack_public_path__ + "static/media/Icon_Estabilidad.b838c8f12cf249ddd5979881bb4022e8.svg";
export { ForwardRef as ReactComponent };